import { render, staticRenderFns } from "./FinalEvaluationOutpatient.vue?vue&type=template&id=cedccb12&scoped=true&"
import script from "./FinalEvaluationOutpatient.vue?vue&type=script&lang=js&"
export * from "./FinalEvaluationOutpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedccb12",
  null
  
)

export default component.exports